import { Box, Button, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import DateInput from "../../../../components/DateInput";
import CommonAutocomplete from "../../../../components/CommonAutocomplete";
import { IntegerOrEmptyFormControl } from "../../../../components/FormControl";
export default function SearchBox ({states, onClickSearch}) {

  const {
    searchCondition,
    changeSearchCondition,
    commodityOwners, 
    products,
    directorEmployees,
    enabledSearch
  } = states;

  const handleClickSearchButton = (_e) => {
    onClickSearch(searchCondition);
  }

  return (
    <Box border="1px solid blue" borderRadius={1} p={2} my={2}>
      <Grid container alignItems="center" spacing={2} mb={2}>
        <Grid item>
          荷主: 
        </Grid>
        <Grid item>
          <CommonAutocomplete
            value={searchCondition.commodityOwner || null}
            onSelect={(_e, newValue) => {
              changeSearchCondition("commodityOwner")(newValue)
            }}
            name="commodityOwnerCd"
            data={commodityOwners}
            filterOptions={(options, { inputValue }) => {
              return options.filter((option) => {
                return option.commodityOwnerName?.includes(inputValue);
              });
            }}
            optionLabel={(option) =>
              option ? option.commodityOwnerCd + " - " + option.commodityOwnerName : ""
            }
            width="400px"
          />
        </Grid>
        <Grid item>
          入荷日付:
        </Grid> 
        <Grid item>
          <DateInput
            value={searchCondition.deliveryDate}
            setValue={changeSearchCondition('deliveryDate')}
          />
        </Grid>
      </Grid>
      <Grid container alignItems="center" columnSpacing={2} mb={2}>
        <Grid item>
          販売原票No: 
        </Grid>
        <Grid item>
          <IntegerOrEmptyFormControl
            value={searchCondition.salesRecordNo || ''}
            setValue={changeSearchCondition('salesRecordNo')}
            onBlurFormat={(v) => v}
            helperTextSx={{mx: 0}}
            inputProps={{sx:{textAlign: "right"}}}
          />
        </Grid>
        <Grid item>
          商品: 
        </Grid>
        <Grid item>
          <CommonAutocomplete
            value={searchCondition.product || null}
            onSelect={(_e, newValue) => {
              changeSearchCondition("product")(newValue)
            }}
            name="productId"
            data={products}
            filterOptions={(options, { inputValue }) => {
              return options.filter((option) => {
                return option.productName?.includes(inputValue);
              });
            }}
            optionLabel={(option) =>
              option ? option.productId + " - " + option.productName : ""
            }
            width="200px"
          />
        </Grid>
        <Grid item>
          担当者: 
        </Grid>
        <Grid item>
          <CommonAutocomplete
            value={searchCondition.directorEmployee || null}
            onSelect={(_e, newValue) => {
              changeSearchCondition("directorEmployee")(newValue)
            }}
            name="directorEmployeeId"
            data={directorEmployees}
            filterOptions={(options, { inputValue }) => {
              return options.filter((option) => {
                return option.directorEmployeeName?.includes(inputValue);
              });
            }}
            optionLabel={(option) =>
              option ? option.directorEmployeeId + " - " + option.directorEmployeeName : ""
            }
            width="200px"
          />
        </Grid>

        <Grid item>
          売立日付: 
        </Grid>
        <Grid item>
          <DateInput
            value={searchCondition.arrivalDate}
            setValue={changeSearchCondition('arrivalDate')}
          />
        </Grid>
        
      </Grid>
      <Grid container alignItems="center" spacing={2}>
        <Grid item>
          販売原票
        </Grid>
        <Grid item>
          <RadioGroup row
            onChange={(_e, v) => changeSearchCondition('salesRecordStatus')(v)}
            value={searchCondition.salesRecordStatus}
          >
            <FormControlLabel value="0" control={<Radio />} label="すべて" />
            <FormControlLabel value="1" control={<Radio />} label="作成済み" />
            <FormControlLabel value="2" control={<Radio />} label="未作成" />
          </RadioGroup>
        </Grid>
        <Grid item>
          QR印刷
        </Grid>
        <Grid item xs>
          <RadioGroup row
            onChange={(_e, v) => changeSearchCondition('qrPrintStatus')(v)}
            value={searchCondition.qrPrintStatus}
          >
            <FormControlLabel value="0" control={<Radio />} label="すべて" />
            <FormControlLabel value="1" control={<Radio />} label="作成済み" />
            <FormControlLabel value="2" control={<Radio />} label="未作成" />
          </RadioGroup>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            onClick={handleClickSearchButton}
            disabled={!enabledSearch}
          >
            検索
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}